import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { KeypadDialogComponent } from 'src/app/dialogs/keypad-dialog/keypad-dialog.component';

@Component({
    selector: 'app-tip-dialog',
    templateUrl: './tip-dialog.component.html',
    styleUrls: ['./tip-dialog.component.scss'],
    standalone: false
})
export class TipDialogComponent implements OnInit, OnDestroy  {
	private orderSubscription: Subscription = null;
	private checkSubscription: Subscription = null;
	$storage: any;
	gratuity: any;
	roundPrecision = 0;
	currencyFormat = '1.0-0';
	tipBehavior: string = 'A';

	constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,
		public entityService: EntityService,
		public dialog: MatDialog,
		public dialogRef: MatDialogRef<TipDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		let that = this;
		this.$storage = this.tabitPayService.$storage;
		this.gratuity = this.data.gratity || { type: "x", amount: 0 };

		let currencyDenom = _.get(this.$storage.rosConfig.currencySettings, 'minimalTipDenomination', 100);
		switch (currencyDenom) {
			case 1:
				this.roundPrecision = 2;
				this.currencyFormat = '1.2-2';
				break;
			case 10:
				this.roundPrecision = 1;
				this.currencyFormat = '1.1-1';
				break;
		}

		this.orderSubscription = this.tabitPayService.orderChanged$.subscribe(() => {
			that.updateParams();
		});
		this.checkSubscription = this.tabitPayService.checkChanged$.subscribe(() => {
			//need to go back to menu
			return;
		});
		this.initParams();
	}

	ngOnInit() {
		if (this.data.diffAmount && this.data.diffAmount > 0) {
			this.setValGratuity(this.data.diffAmount);
		}			
	}

	ngOnDestroy() {
		this.orderSubscription.unsubscribe();
		this.checkSubscription.unsubscribe();
	}

	balanceDue: number;
	orderTotal: number;
	isFullOrderTotal: boolean = true;
	totalTips: number;
	paymentAmount: number;
	initParams() {
		if (this.appService.region == 'US') {
			this.tipBehavior = 'P';
		} else {
			this.tipBehavior = this.$storage.isDelivery || this.$storage.isTA ? 'A' : 'P';
		}

		let check = this.$storage.check;
		this.isFullOrderTotal = true;
		if (check) {
			this.orderTotal = this.$storage.check.$$total;
			this.balanceDue = check.$$balanceDue;
			this.totalTips = check.$$tip;
		} else {
			this.orderTotal = this.$storage.order.itemsTotal;
			this.balanceDue = this.$storage.order.balanceDue;
			this.totalTips = this.$storage.order.totalTips;
		}
		if (this.data.orderTotal) {
			//this.isFullOrderTotal = false;
			this.orderTotal = this.data.orderTotal;
		}
		if (this.data.balanceDue) this.balanceDue = this.data.balanceDue;

		this.paymentAmount = this.data.orderTotal;//this.$storage.order.printData.variables.TOTAL_AMOUNT;
	}

	updateTimeout;
	closing: boolean = false;
	paying: boolean = false;
	updateParams() {
		let that = this;
		this.tipBehavior = this.appService.region == 'US' || !this.$storage.isDelivery ? 'P' : 'A';


		window.clearTimeout(this.updateTimeout);
		this.updateTimeout = window.setTimeout(() => {
			if (that.closing) return;

			if (that.balanceDue === 0) {
				that.appService.animDialog({ title: 'MESSAGES.PAYMENT_ACCEPTED_SUCCESSFULLY', animation: 'check' });
				//that.onPayment.emit(true);
				return
			}

		}, 500);
	}

	//START GRATITY ---------------------------------------------------------------------------->

	slectedGratuity;
	setManualGratuity(mode) {
		if (this.slectedGratuity == mode) {
			this.clearGratuity();
			return;;
		}
		let amount = this.gratuity.type == 'm' && this.gratuity.amount || 0;
		let maxVal = this.$storage.order.itemsTotal;
		if (maxVal <= 50) maxVal = 200;

		let args = {
			title: 'GRATUITY_AMOUNT',
			currency: this.appService.currency,
			maxVal: maxVal,
			response: { amount: amount, amountText: amount + "" },
			enableDecimals: this.appService.regionArgs.enableDecimals
		}
		if (mode == 'p') {
			args = {
				...args,
				...{
					title: 'GRATUITY_PERCENT',
					currency: '%',
					maxVal: 200
				}
			}
		}
		this.showKeypadDialog(args).then(response => {
			if (response) {
				let val = response["amount"]
				if (mode == 'p') {
					this.setGratuity('p', val);
				} else {
					this.setValGratuity(val);
				}
				this.slectedGratuity = mode;
			}
		})
	}

	setGratuity(_type, pVal) {
		if (this.slectedGratuity == pVal) {
			this.clearGratuity();
			return;
		}
		this.slectedGratuity = pVal;
		this.gratuity.type = _type;
		this.gratuity.percent = pVal;
		if (_type === 'n') {
			this.gratuity.amount = 0;
		} else if (!isNaN(pVal)) {
			this.gratuity.amount = this.tabitPayService.calculateGratuityFromPercentage(pVal, this.paymentAmount);
		} else {
			delete this.gratuity.percent;
			delete this.gratuity.amount;
		}
	};

	setFixedValGratuity(val) {
		if (this.slectedGratuity == val) {
			this.clearGratuity();
			return;;
		}
		this.slectedGratuity = val;
		const total = this.paymentAmount;
		let gratuity = this.gratuity;
		gratuity.type = 'mm';

		gratuity.amount = val;
		gratuity.percent = val / total * 100;;
	};

	setValGratuity(val) {
		const total = this.data.isTipMode ? this.orderTotal : this.paymentAmount;
		let gratuity = this.gratuity;
		gratuity.type = 'm';
		gratuity.amount = val;
		gratuity.percent = val / total * 100;
	};


	clearGratuity() {
		this.slectedGratuity = null;
		this.gratuity = { type: "x", amount: 0 };
	}

	//SUBMIT PAYMENT ---------------------------------------------------------------------------->
	cancel() {
		this.dialogRef.close('CANCEL')
	}
	continue() {
		if (this.data.isTipMode) {
			this.dialogRef.close();
		} else {
			let gratuity = this.gratuity;
			this.$storage.order.gratuity = {
				type: 'c',
				amount: 0,
				percent: 0
			}
			this.dialogRef.close(gratuity);
		}
	}

	noTipAlert: boolean = false;
	submit() {
		if (!this.gratuity.amount && this.appService.regionArgs.promptOnNoTip) {
			this.noTipAlert = true;
			setTimeout(() => {
				this.noTipAlert = false;
			}, 500);
			return;
		}
		//START GRATUITY SAVE
		var total = this.$storage.order.grandTotal;
		var gratuity = this.gratuity;
		switch (gratuity.type) {
			case "mm": //fixed amount
				gratuity.percent = gratuity.amount / total * 100
				break;
			case "m"://manual gratuity
				var amount = gratuity.amount;
				if (isNaN(amount) || amount == 0) {
					gratuity.type == 'c';
					gratuity.amount = 0;
					gratuity.percent = 0;
				} else {
					gratuity.percent = gratuity.amount / total * 100
				}
				break;
			case "c":
				gratuity.amount = 0;
				gratuity.percent = 0;
				break;
		}
		this.$storage.order.gratuity = gratuity;
		this.dialogRef.close(gratuity);
	}

	public showKeypadDialog(data: object) {
		return new Promise((resolve, reject) => {

			const dialogRef = this.dialog.open(KeypadDialogComponent, {
				panelClass: 'rounded-dialog',
				width: "340px",
				maxWidth: '95vw',
				data: data
			});
			dialogRef.afterClosed().subscribe(result => {
				if (_.isObject(result) && result["wasChanged"] && result["amount"]) {
					resolve(result);
				}
			});

		})
	}

}
